import {useMutation, useQuery} from '@tanstack/react-query';
import axiosClient from '../services/axiosClient';
import {apiRoutes} from '../routes';

export const useLogin = () =>
  useMutation(async (payload) => {
    const {data} = await axiosClient.post(apiRoutes.login, payload);
    return data;
  });

export const useForgotPassword = () =>
  useMutation(async (payload) => {
    const {data} = await axiosClient.post(apiRoutes.forgotPassword, payload);
    return data;
  });

export const useResetPassword = () =>
  useMutation(async (payload) => {
    const {token, ...restPayload} = payload;
    const {data} = await axiosClient.post(
      `${apiRoutes.resetPassword}/${token}`,
      restPayload,
    );
    return data;
  });

export const useGetUserDetailsQuery = (userId) => {
  return useQuery(
    ['user', userId],
    async () => {
      const {data} = await axiosClient.get(`${apiRoutes.user}/${userId}`);
      return data;
    },
    {
      enabled: !!userId,
    },
  );
};

export const useDeleteUserMutation = () =>
  useMutation(async (userId) => {
    const {data} = await axiosClient.delete(`${apiRoutes.user}/${userId}`);
    return data;
  });

export const createUser = (data) => {
  return axiosClient.post('/account/create-user', data);
};

export const createInvigilator = (data) => {
  return axiosClient.post(
    `/assessments/${data.assessmentId}/create-invigilators`,
    data,
  );
};

export const useCheckAuthStatus = (params, options = {}) => {
  return useQuery(
    ['auth-status'],
    async () => {
      const {data} = await axiosClient.get('/account/check-auth');
      return data;
    },
    {
      retry: false,
      refetchOnWindowFocus: false,
      ...options,
    },
  );
};
